
import { useCourseDetails } from "./useCourseDetails";
import { useEnrollmentStatus } from "./useEnrollmentStatus";
import { useLessonContent } from "./useLessonContent";

/**
 * Main hook that combines all course-related functionality
 */
export function useCourseData(courseId: string | undefined, userId: string | undefined) {
  // Get course details and lessons
  const {
    course,
    lessons,
    isCourseLoading,
    isLessonsLoading,
    courseError,
    lessonsError
  } = useCourseDetails(courseId);

  // Check enrollment status
  const {
    isEnrolled,
    userCourse,
    isCheckingEnrollment,
    enrollmentError
  } = useEnrollmentStatus(userId, courseId, lessons);

  // Manage lesson content and completion
  const {
    activeVideoId,
    activePdfUrl,
    activeLesson,
    handleLessonSelect,
    handleVideoEnd,
    handleLessonComplete,
    isUpdatingProgress
  } = useLessonContent(lessons, userCourse);

  return {
    // Course details
    course,
    lessons,
    isCourseLoading,
    isLessonsLoading,
    courseError,
    lessonsError,
    
    // Enrollment
    isEnrolled,
    userCourse,
    isCheckingEnrollment,
    enrollmentError,
    
    // Lesson content and progress
    activeVideoId,
    activePdfUrl,
    activeLesson,
    handleLessonSelect,
    handleVideoEnd,
    handleLessonComplete,
    isUpdatingProgress
  };
}
